/*
 * Version D behaviour that is not the crisis guard.
 *
 * Right now that is one thing: the hero film's pause control. It is small, but it is not
 * optional -- a looping background film that cannot be stopped fails WCAG 2.2.2, and for
 * some visitors it makes the page unreadable rather than merely annoying.
 *
 * The button is rendered by sections/kjm-hero.liquid only when a film is actually set, so
 * this script does nothing on a hero that is showing a still image.
 */
(function () {
  'use strict';

  function labelFor(button, playing) {
    return playing
      ? button.getAttribute('data-label-pause')
      : button.getAttribute('data-label-play');
  }

  /* ---- YouTube in the hero (Sept 24 call: Adrian swaps the film by pasting a link) ----
     The film file always renders first and stays as the backup. A YouTube player is laid
     over it only once it is actually playing, and taken away again whenever it cannot play.
     It loads after the page has, never under reduced motion, and on a phone only when a
     phone link was given. The player document comes from youtube-nocookie.com. */
  var YT_RE = /(?:youtube(?:-nocookie)?\.com\/(?:watch\?(?:[^#]*&)?v=|embed\/|v\/|shorts\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/;
  function ytId(url) { var m = url && String(url).match(YT_RE); return m ? m[1] : null; }
  function isNarrow() { return window.matchMedia('(max-width: 899px)').matches; }
  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  /* Respect a visitor who declined marketing cookies in Shopify's own consent banner. */
  function consentAllowsYouTube() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return true;
      var fn = cp.thirdPartyMarketingAllowed || cp.marketingAllowed;
      return typeof fn !== 'function' || fn.call(cp) !== false;
    } catch (e) { return true; }
  }
  /* Load YouTube's API once and wait for it by polling. Empire defines its own
     window.onYouTubeIframeAPIReady, so that hook is left alone. */
  function whenYT(cb) {
    if (window.YT && window.YT.Player) { cb(); return; }
    if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
      var s = document.createElement('script');
      s.src = 'https://www.youtube.com/iframe_api';
      s.async = true;
      document.head.appendChild(s);
    }
    var tries = 0;
    (function poll() {
      if (window.YT && window.YT.Player) { cb(); return; }
      if (++tries > 100) { cb(new Error('YouTube API did not load')); return; }
      setTimeout(poll, 100);
    })();
  }

  function wire(button) {
    /* The theme editor re-runs init() on every section reload; one click handler only. */
    if (button.hasAttribute('data-kjm-wired')) return;
    button.setAttribute('data-kjm-wired', '');

    var hero = button.closest('.kjm-hero');
    if (!hero) return;
    var video = hero.querySelector('video');
    var box = hero.querySelector('[data-kjm-yt-box]');

    /* Nothing this button could pause: rather than show a control that lies, remove it. */
    if (!video && !box) {
      button.remove();
      return;
    }

    var player = null;      // the YT.Player, once built
    var ytLive = false;     // true once YouTube has actually started playing
    var ytState = -1;
    var armedId = null;
    var userPaused = false;
    var giveUp = null;

    function playFile() {
      if (!video) return;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    function isPlaying() {
      if (ytLive && player) return ytState === 1;
      return video ? !video.paused : false;
    }

    function sync() {
      var playing = isPlaying();
      button.textContent = labelFor(button, playing);
      button.setAttribute('aria-pressed', playing ? 'false' : 'true');
    }

    button.addEventListener('click', function () {
      if (isPlaying()) {
        userPaused = true;
        if (ytLive && player && player.pauseVideo) player.pauseVideo();
        if (video) video.pause();
      } else {
        userPaused = false;
        /* Someone with reduced motion asked for the film after all: show it. */
        hero.classList.add('kjm-hero--motion-ok');
        if (ytLive && player && player.playVideo) player.playVideo();
        else playFile();
      }
      sync();
    });

    if (video) {
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
    }

    /* A phone shows roughly a third of a widescreen film's width once the frame is covered,
       which turns a stage shot into a face close-up with the headline across it. If an
       upright cut was supplied, use it. The desktop file stays as the element's src so a
       phone without JavaScript still gets a working film rather than a blank hero. */
    function pickSource() {
      if (!video) return;
      var mobile = video.getAttribute('data-kjm-hero-mobile');
      var desktop = video.getAttribute('data-kjm-hero-desktop');
      if (!mobile || !desktop) return;
      var narrow = isNarrow();
      var want = narrow ? mobile : desktop;

      /* Swap the still frame with the film, or a phone briefly shows the wide frame
         cropped to a face before the upright film replaces it. */
      var poster = video.getAttribute(narrow ? 'data-kjm-poster-mobile' : 'data-kjm-poster-desktop');
      if (poster) video.setAttribute('poster', poster);

      if (video.getAttribute('src') === want) return;
      var wasPlaying = !video.paused;
      video.setAttribute('src', want);
      video.load();
      if (wasPlaying) playFile();
    }

    /* Back to the film file: YouTube failed, was blocked, or is no longer wanted. */
    function fallBack() {
      clearTimeout(giveUp);
      if (player && player.destroy) { try { player.destroy(); } catch (e) {} }
      player = null; ytLive = false; ytState = -1; armedId = null;
      if (box) {
        box.innerHTML = '';
        box.classList.remove('is-playing');
        box.classList.remove('kjm-hero__yt--upright');
      }
      if (!userPaused && !reducedMotion()) playFile();
      sync();
    }

    function arm() {
      if (!box || reducedMotion() || !consentAllowsYouTube()) return;
      var url = isNarrow() ? box.getAttribute('data-kjm-yt-mobile') : box.getAttribute('data-kjm-yt');
      var id = ytId(url);
      if (!id) { if (player || armedId) fallBack(); return; }
      if (id === armedId) return;
      if (player || armedId) fallBack();
      armedId = id;
      whenYT(function (err) {
        if (armedId !== id) return;
        if (err || !document.body.contains(box)) { fallBack(); return; }
        var mount = document.createElement('div');
        box.innerHTML = '';
        box.appendChild(mount);
        if (isNarrow()) box.classList.add('kjm-hero__yt--upright');
        giveUp = setTimeout(fallBack, 12000);
        player = new window.YT.Player(mount, {
          host: 'https://www.youtube-nocookie.com',
          videoId: id,
          playerVars: {
            autoplay: 1, mute: 1, controls: 0, loop: 1, playlist: id, playsinline: 1,
            rel: 0, iv_load_policy: 3, disablekb: 1, fs: 0, cc_load_policy: 0,
            origin: window.location.origin
          },
          events: {
            onReady: function (e) {
              var frame = e.target.getIframe && e.target.getIframe();
              if (frame) {
                frame.setAttribute('tabindex', '-1');
                frame.setAttribute('title', '');
              }
              e.target.mute();
              if (!userPaused) e.target.playVideo();
            },
            onStateChange: function (e) {
              ytState = e.data;
              if (e.data === 1 && !ytLive) {
                ytLive = true;
                clearTimeout(giveUp);
                box.classList.add('is-playing');
                if (video) video.pause();
              }
              if (e.data === 0) { e.target.seekTo(0); e.target.playVideo(); }
              sync();
            },
            onError: function () { fallBack(); }
          }
        });
      });
    }

    pickSource();
    var swapTimer;
    window.addEventListener('resize', function () {
      clearTimeout(swapTimer);
      swapTimer = setTimeout(function () { pickSource(); arm(); }, 200);
    });

    /* Someone who has asked their system to reduce motion should not have to ask again on
       every page. Start paused and let them opt in with the same button. */
    if (video && reducedMotion()) {
      video.removeAttribute('autoplay');
      video.pause();
    }

    if (box) {
      if (document.readyState === 'complete') setTimeout(arm, 0);
      else window.addEventListener('load', arm);
    }

    sync();
  }

  function init() {
    var buttons = document.querySelectorAll('[data-kjm-video-toggle]');
    for (var i = 0; i < buttons.length; i++) wire(buttons[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ---- Product gallery thumbnails (30 Sep 2026) ----
     The main image is a scroll-snap row that works on its own; this only makes the
     thumbnails jump to an image and keeps the current one marked as the row moves.
     Also drops the empty paragraphs KJM's descriptions often carry (<p>&nbsp;</p>),
     which printed as blank holes in the middle of a description. */
  function wireGallery(root) {
    if (root.hasAttribute('data-kjm-gallery-wired')) return;
    root.setAttribute('data-kjm-gallery-wired', '');
    var track = root.querySelector('[data-kjm-gallery]');
    var thumbs = root.querySelectorAll('[data-kjm-thumb]');
    if (!track || !thumbs.length) return;
    var still = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function mark(i) {
      for (var k = 0; k < thumbs.length; k++) {
        if (k === i) thumbs[k].setAttribute('aria-current', 'true');
        else thumbs[k].removeAttribute('aria-current');
      }
    }
    for (var n = 0; n < thumbs.length; n++) {
      thumbs[n].addEventListener('click', function () {
        var i = parseInt(this.getAttribute('data-kjm-thumb'), 10) || 0;
        var slide = track.children[i];
        if (!slide) return;
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: still ? 'auto' : 'smooth' });
        mark(i);
      });
    }
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var best = 0, dist = Infinity;
        for (var k = 0; k < track.children.length; k++) {
          var d = Math.abs(track.children[k].offsetLeft - track.offsetLeft - track.scrollLeft);
          if (d < dist) { dist = d; best = k; }
        }
        mark(best);
      }, 80);
    });
  }

  function dropEmptyParagraphs(scope) {
    var ps = scope.querySelectorAll('p');
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i];
      if (p.querySelector('img, iframe, video, svg')) continue;
      if (!p.textContent.replace(/\u00a0/g, ' ').trim()) p.parentNode.removeChild(p);
    }
  }

  function initProductBits() {
    var roots = document.querySelectorAll('[data-kjm-gallery-root]');
    for (var i = 0; i < roots.length; i++) wireGallery(roots[i]);
    /* .site-page .rte: the original theme's plain pages (Contact us carried an empty paragraph
       that opened a 40px gap above its form). */
    var descs = document.querySelectorAll('.kjm-pdp__desc, .kjm-article__body, .site-page .rte');
    for (var d = 0; d < descs.length; d++) dropEmptyParagraphs(descs[d]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProductBits);
  else initProductBits();
  document.addEventListener('shopify:section:load', initProductBits);

  /* The theme editor tears a section down and rebuilds it on every settings change, so
     without this the pause button stops working the moment KJM edits the hero. */
  document.addEventListener('shopify:section:load', init);

  /* --------------------------------------------------------------------------
   * Browse page: filters, facet collapsing, the mobile panel, sort.
   *
   * Everything here is an ENHANCEMENT. The markup ships as a real form with a real submit
   * button and real links, so filtering, sorting and paging all work with this file
   * blocked or broken. What follows only removes steps.
   * ----------------------------------------------------------------------- */

  var FACET_VISIBLE = 6;

  function submitFilters(form) {
    /* Never carry a stale page number into a new result set: filtering to 12 products
       while sitting on page 4 otherwise lands the shopper on an empty page. */
    var stale = form.querySelector('input[name="page"]');
    if (stale) stale.remove();
    form.submit();
  }

  function wireFilterForm(form) {
    var apply = form.querySelector('[data-kjm-filter-submit]');

    form.addEventListener('change', function (event) {
      /* Price is typed, not clicked. Submitting on every keystroke would reload the page
         mid-number, so those commit on blur or Enter instead. */
      if (event.target.type === 'number') return;
      /* In sheet mode selections batch behind one Apply. Submitting here would reload the
         page on every checkbox, which is the behaviour the sheet exists to remove. */
      if (window.KJMSheet && window.KJMSheet.active()) return;
      submitFilters(form);
    });

    form.addEventListener('submit', function () {
      var stale = form.querySelector('input[name="page"]');
      if (stale) stale.remove();
    });

    /* The price inputs keep a visible button, because there is no obvious moment to
       submit a half-typed range. */
    var prices = form.querySelectorAll('input[type="number"]');
    if (apply) {
      if (prices.length) {
        apply.hidden = false;
      } else {
        apply.hidden = true;
      }
    }

    for (var i = 0; i < prices.length; i++) {
      prices[i].addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); submitFilters(form); }
      });
    }
  }

  function collapseFacet(facet) {
    var values = facet.querySelectorAll('.kjm-facet__values label');
    if (values.length <= FACET_VISIBLE + 1) return;

    /* A selected value must never be hidden behind "Show all" — the shopper would have no
       way to see, or switch off, a filter that is actively narrowing their results. */
    var hidden = [];
    var shown = 0;
    for (var i = 0; i < values.length; i++) {
      var checked = values[i].querySelector('input') && values[i].querySelector('input').checked;
      if (checked || shown < FACET_VISIBLE) {
        shown++;
      } else {
        values[i].classList.add('kjm-facet__hidden');
        hidden.push(values[i]);
      }
    }
    if (!hidden.length) return;

    var legend = facet.querySelector('legend');
    var name = legend ? legend.textContent.trim() : '';

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'kjm-facet__more';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = (facet.getAttribute('data-more-label') || 'Show all') + ' (' + values.length + ')';
    if (name) toggle.setAttribute('aria-label', toggle.textContent + ' — ' + name);

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      for (var j = 0; j < hidden.length; j++) {
        hidden[j].classList.toggle('kjm-facet__hidden', open);
      }
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      toggle.textContent = open
        ? (facet.getAttribute('data-more-label') || 'Show all') + ' (' + values.length + ')'
        : (facet.getAttribute('data-less-label') || 'Show fewer');
    });

    facet.appendChild(toggle);
  }

  function wireFilterToggle(button) {
    var panel = document.querySelector('[data-kjm-filters]');
    if (!panel) return;
    button.addEventListener('click', function () {
      var open = panel.classList.toggle('kjm-is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function initCatalogue() {
    var form = document.querySelector('[data-kjm-filter-form]');
    if (form) {
      wireFilterForm(form);
      var facets = form.querySelectorAll('[data-kjm-facet]');
      for (var i = 0; i < facets.length; i++) collapseFacet(facets[i]);
    }

    var toggle = document.querySelector('[data-kjm-filter-toggle]');
    if (toggle) wireFilterToggle(toggle);

    var sort = document.querySelector('[data-kjm-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var sortForm = sort.closest('form');
        if (sortForm) submitFilters(sortForm);
      });
      var sortButton = sort.closest('form') && sort.closest('form').querySelector('button[type="submit"]');
      if (sortButton) sortButton.hidden = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCatalogue);
  } else {
    initCatalogue();
  }
  document.addEventListener('shopify:section:load', initCatalogue);

  /* --------------------------------------------------------------------------
   * Product page: quantity stepper, and the price following the chosen variant.
   *
   * Enhancement only. The stepper buttons sit beside a real number input, and the variant
   * <select> is the form's own `id` field, so with this file blocked a shopper can still
   * type a quantity, pick a variant and add to the bag.
   * ----------------------------------------------------------------------- */

  function initProduct() {
    var qtyInput = document.querySelector('.kjm-qty input');
    var steppers = document.querySelectorAll('[data-kjm-qty]');
    for (var i = 0; i < steppers.length; i++) {
      (function (button) {
        button.addEventListener('click', function () {
          if (!qtyInput) return;
          var step = parseInt(button.getAttribute('data-kjm-qty'), 10) || 0;
          var next = (parseInt(qtyInput.value, 10) || 1) + step;
          if (next < 1) next = 1;
          qtyInput.value = next;
          /* Anything listening for a quantity change (an app, a cart widget) expects an
             event, and setting .value alone does not fire one. */
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      })(steppers[i]);
    }

    var select = document.querySelector('[data-kjm-variant-select]');
    var price = document.querySelector('[data-kjm-price]');
    if (select && price) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        var next = opt && opt.getAttribute('data-price');
        /* The price is re-rendered by Shopify on submit regardless; this only stops the
           page showing the previous variant's price while the shopper decides. */
        if (next) price.textContent = next;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProduct);
  } else {
    initProduct();
  }
  document.addEventListener('shopify:section:load', initProduct);

  /* --------------------------------------------------------------------------
   * Rotating messages, and the bag's quantity steppers.
   * ----------------------------------------------------------------------- */

  function initVoices() {
    var root = document.querySelector('[data-kjm-voices]');
    if (!root) return;
    var cards = root.querySelectorAll('[data-kjm-voice]');
    var dots = root.querySelectorAll('[data-kjm-voice-dot]');
    if (cards.length < 2) return;
    var at = 0;

    function show(next) {
      at = (next + cards.length) % cards.length;
      for (var i = 0; i < cards.length; i++) {
        if (i === at) {
          cards[i].removeAttribute('data-kjm-voice-inactive');
        } else {
          cards[i].setAttribute('data-kjm-voice-inactive', '');
        }
      }
      for (var j = 0; j < dots.length; j++) {
        var on = j === at;
        dots[j].classList.toggle('kjm-is-on', on);
        if (on) { dots[j].setAttribute('aria-current', 'true'); } else { dots[j].removeAttribute('aria-current'); }
      }
    }

    var steps = root.querySelectorAll('[data-kjm-voice-step]');
    for (var k = 0; k < steps.length; k++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          show(at + (parseInt(btn.getAttribute('data-kjm-voice-step'), 10) || 1));
        });
      })(steps[k]);
    }
    for (var m = 0; m < dots.length; m++) {
      (function (dot, index) {
        dot.addEventListener('click', function () { show(index); });
      })(dots[m], m);
    }
  }

  function initBag() {
    var steppers = document.querySelectorAll('[data-kjm-line-qty]');
    if (!steppers.length) return;

    for (var i = 0; i < steppers.length; i++) {
      (function (button) {
        button.addEventListener('click', function () {
          var wrap = button.parentNode;
          var input = wrap.querySelector('[data-kjm-line-input]');
          if (!input) return;
          var step = parseInt(button.getAttribute('data-kjm-line-qty'), 10) || 0;
          var next = (parseInt(input.value, 10) || 0) + step;
          /* 0 is a legitimate value here -- it is how Shopify removes a line. */
          if (next < 0) next = 0;
          input.value = next;
          var form = input.form;
          if (form) form.submit();
        });
      })(steppers[i]);
    }

    /* A typed quantity commits on blur, so the visible Update button is only needed
       without JavaScript. */
    var inputs = document.querySelectorAll('[data-kjm-line-input]');
    for (var j = 0; j < inputs.length; j++) {
      inputs[j].addEventListener('change', function () {
        if (this.form) this.form.submit();
      });
    }
    var update = document.querySelector('[data-kjm-cart-update]');
    if (update) update.hidden = true;
  }

  function initExtras() { initVoices(); initBag(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initExtras);
  } else {
    initExtras();
  }
  document.addEventListener('shopify:section:load', initExtras);

  /* --------------------------------------------------------------------------
   * Long product descriptions collapse on a phone.
   *
   * The button ships hidden and is only revealed when the description is genuinely longer
   * than the clamp, so short ones never get a pointless "Read more". With this file
   * blocked nothing is clamped and the whole description is visible, which is the correct
   * failure direction for the only copy on the page that sells the product.
   * ----------------------------------------------------------------------- */

  function initDescription() {
    var wrap = document.querySelector('[data-kjm-desc-wrap]');
    if (!wrap) return;
    var desc = wrap.querySelector('[data-kjm-desc]');
    var btn = wrap.querySelector('[data-kjm-desc-toggle]');
    if (!desc || !btn) return;

    function label(expanded) {
      btn.textContent = expanded ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    function apply() {
      var narrow = window.matchMedia('(max-width: 899px)').matches;
      desc.classList.remove('kjm-is-clamped');

      /* Phones fold at 16em, desktops at 20em (the max-heights in kjm-theme.css). Desktop
         folds too since 30 Sep 2026: the description now sits under Add to bag at every
         width, and a long one had left a column of empty page beside it.
         Measure unclamped, then decide. The 40px margin stops a description that is barely
         over the limit from getting a toggle that reveals two more words. */
      var limit = parseFloat(getComputedStyle(desc).fontSize || '14') * (narrow ? 16 : 20);
      if (desc.scrollHeight > limit + 40) {
        desc.classList.add('kjm-is-clamped');
        btn.hidden = false;
        label(false);
      } else {
        btn.hidden = true;
      }
    }

    btn.addEventListener('click', function () {
      var nowClamped = desc.classList.toggle('kjm-is-clamped');
      label(!nowClamped);
      if (nowClamped) desc.scrollIntoView({ block: 'nearest' });
    });

    apply();

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(apply, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDescription);
  } else {
    initDescription();
  }
  document.addEventListener('shopify:section:load', initDescription);

  /* --------------------------------------------------------------------------
   * Mobile filtering: sticky action bar + filter sheet.
   *
   * The inline accordion this replaces was measured on /collections/all: it expanded to
   * 3,277px (four phone screens), pushed the grid down 3,303px so no result stayed in
   * view, and reloaded the whole page on every one of 95 checkboxes because the form
   * submitted on change.
   *
   * In sheet mode selections BATCH: tick as many as you like, then one Apply, one reload.
   * On desktop nothing here runs and the panel stays the sidebar it already was.
   *
   * Progressive enhancement is load-bearing. The bar and the sheet furniture ship hidden
   * in the markup and are revealed here, so with this file blocked the original inline
   * button, panel and sort control are all still present and working.
   * ----------------------------------------------------------------------- */

  function initFilterSheet() {
    var panel = document.querySelector('[data-kjm-filters]');
    var bar = document.querySelector('[data-kjm-bar]');
    if (!panel || !bar) return;

    var form = panel.querySelector('[data-kjm-filter-form]');
    var head = panel.querySelector('[data-kjm-sheet-head]');
    var foot = panel.querySelector('[data-kjm-sheet-foot]');
    var openBtn = bar.querySelector('[data-kjm-bar-filter]');
    var closeBtn = panel.querySelector('[data-kjm-sheet-close]');
    var countPill = bar.querySelector('[data-kjm-bar-count]');
    var barSort = bar.querySelector('[data-kjm-bar-sort]');
    var applyBtn = panel.querySelector('[data-kjm-sheet-apply]');

    var sortSelect = document.querySelector('[data-kjm-sort]');
    var sortHome = sortSelect ? sortSelect.parentNode : null;
    var sortNext = sortSelect ? sortSelect.nextSibling : null;

    var sheetMode = false;

    function activeCount() {
      return form ? form.querySelectorAll('input[type="checkbox"]:checked').length : 0;
    }

    function paintCount() {
      var n = activeCount();
      if (!countPill) return;
      countPill.textContent = n;
      countPill.hidden = n === 0;
      if (applyBtn) {
        applyBtn.textContent = applyBtn.getAttribute('data-label') || applyBtn.textContent;
      }
    }

    function openSheet() {
      panel.classList.add('kjm-is-open');
      document.body.classList.add('kjm-sheet-locked');
      openBtn.setAttribute('aria-expanded', 'true');
      /* Send focus into the sheet, or a keyboard user is left on a button behind it. */
      if (closeBtn) closeBtn.focus();
    }

    function closeSheet() {
      panel.classList.remove('kjm-is-open');
      document.body.classList.remove('kjm-sheet-locked');
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.focus();
    }

    function enterSheetMode() {
      if (sheetMode) return;
      sheetMode = true;
      document.documentElement.classList.add('kjm-js-sheet');
      bar.hidden = false;
      if (head) head.hidden = false;
      if (foot) foot.hidden = false;
      /* Move the real sort control into the bar rather than building a second one, so
         there is only ever one source of truth for the sort value. */
      if (sortSelect && barSort) barSort.appendChild(sortSelect);
      panel.classList.remove('kjm-is-open');
      paintCount();
    }

    function leaveSheetMode() {
      if (!sheetMode) return;
      sheetMode = false;
      document.documentElement.classList.remove('kjm-js-sheet');
      document.body.classList.remove('kjm-sheet-locked');
      bar.hidden = true;
      if (head) head.hidden = true;
      if (foot) foot.hidden = true;
      if (sortSelect && sortHome) sortHome.insertBefore(sortSelect, sortNext);
      panel.classList.remove('kjm-is-open');
    }

    function sync() {
      if (window.matchMedia('(max-width: 899px)').matches) { enterSheetMode(); }
      else { leaveSheetMode(); }
    }

    openBtn.addEventListener('click', function () {
      if (panel.classList.contains('kjm-is-open')) { closeSheet(); } else { openSheet(); }
    });
    if (closeBtn) closeBtn.addEventListener('click', closeSheet);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('kjm-is-open')) closeSheet();
    });

    if (form) {
      form.addEventListener('change', paintCount);
      /* The sheet's Apply submits the form, so nothing else needs to. */
      form.addEventListener('submit', function () {
        document.body.classList.remove('kjm-sheet-locked');
      });
    }

    sync();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(sync, 150); });

    /* Tell the rest of the script that filtering is handled here now, so the older
       submit-on-change behaviour stands down on phones. */
    window.KJMSheet = { active: function () { return sheetMode; } };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterSheet);
  } else {
    initFilterSheet();
  }
  document.addEventListener('shopify:section:load', initFilterSheet);

  /* --------------------------------------------------------------------------
   * Mobile header: search collapses behind an icon.
   *
   * Empire renders the search field as a permanent second row, 52px of a STICKY header on
   * every page. This hides it behind a control in the top row and reveals it on tap,
   * giving a one-row header of about 66px.
   *
   * The field is only hidden once this runs, so with scripting blocked search stays open
   * and reachable. On a 1,262-product store that is the one thing that must not break.
   * ----------------------------------------------------------------------- */

  var SEARCH_ICON =
    '<svg class="kjm-search-open-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true">'
    + '<circle cx="11" cy="11" r="7"></circle><path d="M20 20l-3.5-3.5"></path></svg>'
    + '<svg class="kjm-search-close" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true">'
    + '<path d="M6 6l12 12M18 6L6 18"></path></svg>';

  function initHeaderSearch() {
    var header = document.querySelector('.site-header');
    var main = header && header.querySelector('.site-header-main');
    var field = header && header.querySelector('.live-search');
    if (!header || !main || !field) return;
    if (main.querySelector('.kjm-search-toggle')) return;   // already wired

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kjm-search-toggle';
    btn.innerHTML = SEARCH_ICON;
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', main.getAttribute('data-kjm-search-label') || 'Search');
    main.appendChild(btn);

    function close() {
      header.classList.remove('kjm-search-open');
      btn.setAttribute('aria-expanded', 'false');
    }

    btn.addEventListener('click', function () {
      var open = header.classList.toggle('kjm-search-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        /* Opening a search box without putting the cursor in it makes the shopper tap
           twice for one intention. */
        var input = field.querySelector('input[type="search"], input[type="text"], input[name="q"]');
        if (input) input.focus();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header.classList.contains('kjm-search-open')) { close(); btn.focus(); }
    });

    function sync() {
      if (window.matchMedia('(max-width: 899px)').matches) {
        document.documentElement.classList.add('kjm-js-search');
      } else {
        document.documentElement.classList.remove('kjm-js-search');
        close();
      }
    }
    sync();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(sync, 150); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderSearch);
  } else {
    initHeaderSearch();
  }

  /* ---- the free-book offer (sections/kjm-newsletter.liquid) ------------------------
     Three jobs, all fail-open:
     1. A card's free-book link is rendered hidden and shown only when its anchor is a
        switched-on offer on this page, so a card never promises a book the page cannot
        give -- not even with JavaScript off.
     2. Shopify's success flag is page-wide. If the page came back to the anchor of a
        DIFFERENT customer form that is on this page, this form's thank-you is put away.
        Any other fragment (the offer's own anchor, another template's form) leaves it.
     3. An address that is already a customer comes back with neither success nor error
        (forum-reported; UNVERIFIED until one real test sign-up). If the address bar shows
        a customer-form return and this form shows no error, the book is handed over
        anyway -- the file is public, so this gives away nothing. */
  function initOffers() {
    var links = document.querySelectorAll('[data-kjm-offer-link]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      var target = href.charAt(0) === '#' ? document.getElementById(href.slice(1)) : null;
      links[i].hidden = !(target && target.hasAttribute('data-kjm-offer'));
    }

    var params = new URLSearchParams(window.location.search);
    var posted = params.get('customer_posted') === 'true';
    var returned = params.get('form_type') === 'customer';

    var forms = document.querySelectorAll('form.kjm-news__form');
    for (var f = 0; f < forms.length; f++) {
      var form = forms[f];
      var fields = form.querySelector('[data-kjm-form-fields]');
      var ok = form.querySelector('[data-kjm-form-ok]');

      var other = null;
      if (window.location.hash.length > 1) {
        try {
          other = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
        } catch (err) {
          other = null;
        }
      }
      if (ok && other && other.tagName === 'FORM' && other !== form) {
        ok.hidden = true;
        if (fields) fields.hidden = false;
      }

      var already = form.querySelector('[data-kjm-already]');
      if (already && returned && !posted && !form.querySelector('.kjm-news__err')) {
        already.hidden = false;
        if (fields) fields.hidden = true;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOffers);
  } else {
    initOffers();
  }
  /* The theme editor rebuilds a section on every change; re-check the card links. */
  document.addEventListener('shopify:section:load', initOffers);


  /* --------------------------------------------------------------------------
   * Landing pages (Oct 1, 2026): the size picker keeps the one button pointed at the
   * chosen variant. The button is a cart permalink, so with JavaScript off it still buys
   * the first available variant.
   * ----------------------------------------------------------------------- */
  function initLanding() {
    var boxes = document.querySelectorAll('[data-kjm-landing-buy-box]');
    for (var i = 0; i < boxes.length; i++) {
      (function (box) {
        var sel = box.querySelector('[data-kjm-landing-variant]');
        var cta = box.querySelector('[data-kjm-landing-cta]');
        if (!sel || !cta || sel.hasAttribute('data-kjm-wired')) return;
        sel.setAttribute('data-kjm-wired', '');
        function sync() {
          var opt = sel.options[sel.selectedIndex];
          cta.setAttribute('href', cta.getAttribute('data-base') + sel.value + ':1');
          if (opt && opt.disabled) cta.setAttribute('aria-disabled', 'true');
          else cta.removeAttribute('aria-disabled');
        }
        sel.addEventListener('change', sync);
        sync();
      })(boxes[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLanding);
  else initLanding();
  document.addEventListener('shopify:section:load', initLanding);


  /* --------------------------------------------------------------------------
   * Lead pop-ups: the homepage game and the collection resources (30 Sep 2026,
   * Sept 24 call 2.32-2.40, 2.74).
   *
   * Each is a <dialog data-kjm-lead="key"> rendered by its section. It opens once the
   * shopper has scrolled to data-kjm-lead-depth of the page, once per visitor per key, and
   * never:
   *   - in a visit where the crisis guard has fired (sessionStorage 'kjm-crisis-visit',
   *     set by kjm-crisis-guard.js), or while this page carries its crisis flags;
   *   - again after a sign-up, or within data-kjm-lead-days of being closed;
   *   - where <dialog> is not supported (the page simply has no pop-up).
   * If the crisis flags appear while it is open (a crisis search typed in the header), it
   * closes at once.
   *
   * The sign-up is a normal form submission, because Shopify's spam check only passes a form
   * it submits itself (see wireLeadForm). The same page comes back and the pop-up reopens on
   * its result, so the shopper is never moved to another page (2.40).
   * ----------------------------------------------------------------------- */

  var LEAD_STORE = 'kjm-lead:';

  function leadGet(k) { try { return window.localStorage.getItem(LEAD_STORE + k); } catch (e) { return null; } }
  function leadSet(k, v) { try { window.localStorage.setItem(LEAD_STORE + k, v); } catch (e) { /* private mode */ } }
  function sessGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function sessSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  function sessDel(k) { try { window.sessionStorage.removeItem(k); } catch (e) { /* private mode */ } }

  function crisisNow() {
    var root = document.documentElement;
    return !!(sessGet('kjm-crisis-visit') || root.hasAttribute('data-kjm-crisis') || root.hasAttribute('data-kjm-ps-crisis'));
  }

  function leadBlocked(key, days) {
    var v = leadGet(key);
    if (!v) return false;
    if (v === 'done') return true;
    var when = parseInt(v, 10);
    if (!when) return false;
    return (Date.now() - when) < days * 86400000;
  }

  function showOk(dialog, already) {
    var fields = dialog.querySelector('[data-kjm-lead-fields]');
    var ok = dialog.querySelector('[data-kjm-lead-ok]');
    if (fields) fields.hidden = true;
    if (ok) {
      ok.hidden = false;
      var msg = ok.querySelector('[data-kjm-lead-ok-msg]');
      if (already && msg && msg.getAttribute('data-already') && !dialog.hasAttribute('data-kjm-game')) {
        msg.textContent = msg.getAttribute('data-already');
      }
    }
    if (dialog.hasAttribute('data-kjm-game')) gameShowCode(dialog);
    leadSet(dialog.getAttribute('data-kjm-lead'), 'done');
  }

  function showErr(form, text) {
    var err = form.querySelector('[data-kjm-lead-err]');
    if (!err) return;
    err.textContent = text || err.getAttribute('data-generic') || '';
    err.hidden = false;
  }

  /* The sign-up is a NORMAL form submission, and Shopify's spam protection (hCaptcha, on for
     this store's customer forms) is left entirely to Shopify. What real tests found (Oct 1, 2026):
     - a fetch is refused with a 400 (no hCaptcha answer), which the old code read as "already a
       customer" -- a success that never reached the admin;
     - Shopify attaches its check when the shopper first clicks into the form, and a check
       attached inside a MODAL dialog (the browser's top layer) never answers, while the same
       check attached to a non-modal one passes at once in a normal Chrome. So the pop-ups now
       open non-modally (leadOpen), and nothing here touches the captcha.
     Shopify then posts the form itself (or, if its check needs it, shows its own challenge
     page) and returns the shopper to this page, where the pop-up reopens on its result. */
  function wireLeadForm(dialog) {
    var form = dialog.querySelector('form.kjm-lead__form');
    if (!form || form.hasAttribute('data-kjm-lead-wired')) return;
    form.setAttribute('data-kjm-lead-wired', '');
    form.addEventListener('submit', function (e) {
      if (dialog.hasAttribute('data-kjm-lead-preview')) { e.preventDefault(); return; }
      if (dialog.hasAttribute('data-kjm-game')) gameTagReward(dialog, form);
      var key = dialog.getAttribute('data-kjm-lead');
      sessSet('kjm-lead-pending', key);
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');
      /* A check started before Shopify's widget has finished loading can wait forever (seen
         with an instant autofill-and-send); a second try then passes at once. So if the page is
         still here after 6 seconds and no puzzle is on screen, ask Shopify to send it again. */
      setTimeout(function () {
        if (sessGet('kjm-lead-pending') !== key || !document.body.contains(form)) return;
        var puzzle = [].some.call(document.querySelectorAll('iframe[src*="hcaptcha"]'), function (f) {
          var host = f.parentElement || f;
          return f.getBoundingClientRect().height > 100 && window.getComputedStyle(host).visibility === 'visible';
        });
        if (!puzzle && typeof form.submit === 'function') form.submit();
      }, 6000);
    });
  }

  /* Shopify attaches its spam check when the shopper first clicks into the form. Attaching it
     the moment the pop-up opens gives it time to load before the shopper presses the button.
     Shopify.captcha.protect is Shopify's own call for this. */
  function leadProtect(dialog) {
    var form = dialog.querySelector('form.kjm-lead__form');
    var cap = window.Shopify && window.Shopify.captcha;
    if (!form || dialog.hasAttribute('data-kjm-lead-preview') || form.hasAttribute('data-cptcha')) return;
    if (cap && typeof cap.protect === 'function') {
      try { cap.protect(form); } catch (err) { /* Shopify binds it on first focus instead */ }
    }
  }

  /* On the way back from Shopify: was this pop-up's sign-up taken, refused, or an address
     that is already a customer (which comes back with neither)? */
  function leadReturned(dialog) {
    var params = new URLSearchParams(window.location.search);
    var hashForm = window.location.hash.length > 1 && dialog.querySelector('form#' + window.location.hash.slice(1).replace(/[^\w-]/g, ''));
    var back = params.get('customer_posted') === 'true' || params.get('form_type') === 'customer' || !!hashForm;
    if (!back) return false;
    sessDel('kjm-lead-pending');
    var serverErr = dialog.querySelector('[data-kjm-lead-server-err]');
    if (params.get('customer_posted') === 'true') {
      showOk(dialog, false);
    } else if (serverErr && serverErr.textContent.trim()) {
      var form = dialog.querySelector('form.kjm-lead__form');
      if (form) showErr(form, serverErr.textContent.trim());
      if (dialog.hasAttribute('data-kjm-game')) {
        /* Back on the gift step, so the shopper can correct the address. */
        var pick = parseInt(leadGet(gameKey(dialog)), 10) || 0;
        gameShowReward(dialog, pick);
        var ask = dialog.querySelector('[data-kjm-game-step="ask"]');
        var gift = dialog.querySelector('[data-kjm-game-step="gift"]');
        if (ask) ask.hidden = true;
        if (gift) gift.hidden = false;
      }
    } else {
      showOk(dialog, true);
    }
    return true;
  }

  /* ---- the game ---- */

  function gameKey(dialog) { return dialog.getAttribute('data-kjm-lead') + ':reward'; }

  function gamePickReward(dialog) {
    var kept = leadGet(gameKey(dialog));
    var rewards = dialog.querySelectorAll('[data-kjm-game-reward]');
    if (kept !== null && rewards[parseInt(kept, 10)]) return parseInt(kept, 10);
    var total = 0, i;
    for (i = 0; i < rewards.length; i++) total += Math.max(0, parseInt(rewards[i].getAttribute('data-weight'), 10) || 0);
    var pick = 0;
    if (total > 0) {
      var r = Math.random() * total;
      for (i = 0; i < rewards.length; i++) {
        r -= Math.max(0, parseInt(rewards[i].getAttribute('data-weight'), 10) || 0);
        if (r < 0) { pick = i; break; }
      }
    }
    leadSet(gameKey(dialog), String(pick)); /* no re-rolling by reloading */
    return pick;
  }

  function gameShowReward(dialog, pick) {
    var rewards = dialog.querySelectorAll('[data-kjm-game-reward]');
    for (var i = 0; i < rewards.length; i++) rewards[i].hidden = (i !== pick);
  }

  function gameTagReward(dialog, form) {
    var tags = form.querySelector('[data-kjm-lead-tags]');
    var pick = parseInt(leadGet(gameKey(dialog)), 10) || 0;
    var amount = dialog.querySelector('[data-kjm-game-reward="' + pick + '"] strong');
    if (tags && amount && tags.value.indexOf('game-reward-') === -1) {
      tags.value += ', game-reward-' + amount.textContent.trim().replace(/[^0-9a-z]+/gi, '').toLowerCase();
    }
  }

  function gameShowCode(dialog) {
    var pick = parseInt(leadGet(gameKey(dialog)), 10) || 0;
    var codes = dialog.querySelectorAll('[data-kjm-game-code]');
    for (var i = 0; i < codes.length; i++) codes[i].hidden = (i !== pick);
    gameShowReward(dialog, pick);
    var gift = dialog.querySelector('[data-kjm-game-step="gift"]');
    var ask = dialog.querySelector('[data-kjm-game-step="ask"]');
    if (ask) ask.hidden = true;
    if (gift) gift.hidden = false;
  }

  function wireGame(dialog) {
    if (dialog.hasAttribute('data-kjm-game-wired')) return;
    dialog.setAttribute('data-kjm-game-wired', '');
    var qs = dialog.querySelectorAll('[data-kjm-game-q]');
    if (!qs.length) return;
    /* One question per visitor, chosen once and kept. */
    var qKey = dialog.getAttribute('data-kjm-lead') + ':q';
    var qi = parseInt(leadGet(qKey), 10);
    if (isNaN(qi) || !qs[qi]) { qi = Math.floor(Math.random() * qs.length); leadSet(qKey, String(qi)); }
    for (var i = 0; i < qs.length; i++) qs[i].hidden = (i !== qi);

    var answers = qs[qi].querySelectorAll('[data-kjm-game-answer]');
    for (var a = 0; a < answers.length; a++) {
      answers[a].addEventListener('click', function () {
        var right = this.getAttribute('data-right');
        var mine = this.getAttribute('data-kjm-game-answer');
        var fb = dialog.querySelector('[data-kjm-game-feedback]');
        if (fb) {
          fb.textContent = (mine === right)
            ? fb.getAttribute('data-right')
            : (fb.getAttribute('data-wrong') || '').replace('%ANSWER%', this.getAttribute('data-right-text') || '');
        }
        var pick = gamePickReward(dialog);
        gameShowReward(dialog, pick);
        dialog.querySelector('[data-kjm-game-step="ask"]').hidden = true;
        var gift = dialog.querySelector('[data-kjm-game-step="gift"]');
        gift.hidden = false;
        var email = gift.querySelector('input[type="email"]:not([disabled])');
        if (email) email.focus(); else { var h = gift.querySelector('[data-kjm-game-feedback]'); if (h) { h.setAttribute('tabindex', '-1'); h.focus(); } }
      });
    }

    var copy = dialog.querySelector('[data-kjm-game-copy]');
    if (copy) {
      copy.addEventListener('click', function () {
        var shown = dialog.querySelector('[data-kjm-game-code]:not([hidden]) code');
        if (!shown) return;
        var text = shown.textContent.trim();
        var done = function () { copy.textContent = copy.getAttribute('data-copied'); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, function () {});
      });
    }
  }

  /* ---- opening and closing ---- */

  /* Opened NON-modally (see wireLeadForm: Shopify's spam check never answers inside the top
     layer a modal dialog uses). So the dimmed page behind, Escape and keeping keyboard focus
     inside are done here, the way showModal() did them. */
  var leadBackdrop = null;
  function leadOpen(dialog) {
    if (dialog.open || typeof dialog.show !== 'function') return;
    if (!leadBackdrop) {
      leadBackdrop = document.createElement('div');
      leadBackdrop.className = 'kjm-lead-backdrop';
      leadBackdrop.addEventListener('click', function () {
        var open = document.querySelector('dialog.kjm-lead[open]');
        if (open) leadClose(open);
      });
    }
    document.body.appendChild(leadBackdrop);
    dialog.setAttribute('aria-modal', 'true');
    dialog.show();
    leadProtect(dialog);
    document.documentElement.classList.add('kjm-lead-open');
    /* Focus goes to the heading, so it is read first and a phone keyboard does not jump up
       over the pop-up. On the way back from a sign-up the heading may be hidden; then the
       success message takes it. */
    var target = dialog.querySelector('.kjm-lead__title');
    if (!target || !target.getClientRects().length) target = dialog.querySelector('[data-kjm-lead-ok-msg]');
    if (target && target.getClientRects().length) {
      target.setAttribute('tabindex', '-1');
      target.focus();
    }
  }

  function leadClose(dialog) {
    if (dialog.open) dialog.close();
  }

  function wireLead(dialog) {
    if (dialog.hasAttribute('data-kjm-lead-wired')) return;
    dialog.setAttribute('data-kjm-lead-wired', '');
    var key = dialog.getAttribute('data-kjm-lead');
    var days = parseInt(dialog.getAttribute('data-kjm-lead-days'), 10) || 14;
    var depth = parseFloat(dialog.getAttribute('data-kjm-lead-depth')) || 0.5;
    var inEditor = !!(window.Shopify && window.Shopify.designMode);

    wireLeadForm(dialog);
    if (dialog.hasAttribute('data-kjm-game')) wireGame(dialog);

    var closers = dialog.querySelectorAll('[data-kjm-lead-close]');
    for (var c = 0; c < closers.length; c++) closers[c].addEventListener('click', function () { leadClose(dialog); });
    /* A click on the dimmed page around the panel closes it too. */
    dialog.addEventListener('click', function (e) { if (e.target === dialog) leadClose(dialog); });
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('kjm-lead-open');
      if (leadBackdrop && leadBackdrop.parentNode) leadBackdrop.parentNode.removeChild(leadBackdrop);
      if (!inEditor && leadGet(key) !== 'done') leadSet(key, String(Date.now()));
    });

    /* Back from Shopify after this pop-up's sign-up: reopen on the result. */
    if (sessGet('kjm-lead-pending') === key && leadReturned(dialog)) {
      leadOpen(dialog);
      return;
    }

    if (inEditor) return; /* the editor opens it on selection, below */
    if (leadBlocked(key, days) || crisisNow()) return;

    var fired = false;
    function check() {
      if (fired) return;
      var doc = document.documentElement;
      var seen = (window.scrollY + window.innerHeight) / Math.max(doc.scrollHeight, 1);
      if (seen < depth) return;
      fired = true;
      window.removeEventListener('scroll', onScroll);
      if (crisisNow() || document.querySelector('dialog.kjm-lead[open]')) return;
      leadOpen(dialog);
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; check(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initLeads() {
    var ds = document.querySelectorAll('dialog[data-kjm-lead]');
    for (var i = 0; i < ds.length; i++) wireLead(ds[i]);
  }

  /* Escape closes; Tab stays inside the open pop-up (what a modal dialog did on its own). */
  document.addEventListener('keydown', function (e) {
    var open = document.querySelector('dialog.kjm-lead[open]');
    if (!open) return;
    if (e.key === 'Escape') { leadClose(open); return; }
    if (e.key !== 'Tab') return;
    var f = open.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], inside = open.contains(document.activeElement);
    if (e.shiftKey && (document.activeElement === first || !inside)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !inside)) { e.preventDefault(); first.focus(); }
  });

  /* Close at once if a crisis search shows up while a pop-up is open. */
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (!crisisNow()) return;
      var open = document.querySelectorAll('dialog.kjm-lead[open]');
      for (var i = 0; i < open.length; i++) open[i].close();
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['data-kjm-crisis', 'data-kjm-ps-crisis'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLeads);
  else initLeads();

  /* Theme editor: open the pop-up while its section is selected, so it can be edited. */
  document.addEventListener('shopify:section:load', initLeads);
  document.addEventListener('shopify:section:select', function (e) {
    var d = document.querySelector('dialog[data-kjm-lead-section="' + e.detail.sectionId + '"]');
    if (d) { wireLead(d); leadOpen(d); }
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var d = document.querySelector('dialog[data-kjm-lead-section="' + e.detail.sectionId + '"]');
    if (d) leadClose(d);
  });


})();
